var React = require('react');

function Rss (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M303.74 463.21c-8.35-154.6-132.18-278.59-286.95-286.95A16 16 0 0 0 0 192.25v48.07a16 16 0 0 0 14.89 16c111.83 7.28 201.47 96.7 208.77 208.77a16 16 0 0 0 16 14.89h48.07a16 16 0 0 0 16-16.79zM16.5 32A16 16 0 0 0 0 48v48.08a16 16 0 0 0 15.45 16c191.18 7.84 344.63 161.32 352.47 352.47a16 16 0 0 0 16 15.45H432a16 16 0 0 0 16-16.5C439.6 229.68 251.46 40.45 16.5 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 416a64 64 0 1 1 64 64 64 64 0 0 1-64-64z","className":"fa-primary","key":2})]);
}

Rss.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Rss;

Rss.default = Rss;
